// extracted by mini-css-extract-plugin
module.exports = {"title":"style__title__CVvZi","callouts":"style__callouts__Bizac"};